import {gsap} from "../../lib/gsap";

export default class BlockCertification {
	static init() {
		let blocks = document.querySelectorAll('.block-certification');

		blocks.forEach( (block) => {

			const swiperCertification = block.querySelector('.slider-certification');
			const swiperCertificationNav = block.querySelector('.slider-certification-nav');
			const followerCertification = block.querySelector('.cursor-follower');
			new Swiper(swiperCertification, {
				grabCursor: true,
				spaceBetween: 20,
				slidesPerView: "auto",
				watchOverflow: true,
				breakpoints: {
					769: {
						slidesPerView: 3
					}
				},
				navigation: {
					prevEl: swiperCertificationNav.querySelector('.swiper-pill-nav-prev'),
					nextEl: swiperCertificationNav.querySelector('.swiper-pill-nav-next'),
				},
				on: {
					init: (swiper) => {
						this.toggleNavigation(swiper, swiperCertification, swiperCertificationNav);
					},
					resize:  (swiper) => {
						this.toggleNavigation(swiper, swiperCertification, swiperCertificationNav);
					},
					update: (swiper) => {
						this.toggleNavigation(swiper, swiperCertification, swiperCertificationNav);
					},
					touchStart: () => {
						gsap.to(followerCertification, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					},
					touchEnd: () => {
						gsap.to(followerCertification, 0.2, {
							scale: 1,
							opacity: 1
						});
					}
				}
			});

		});
	}

	static toggleNavigation(swiper, container, navigation){
		if (swiper.slides.length <= swiper.params.slidesPerView) {
			container.closest('.cursor-follower-inner').classList.add("swiper-disabled-follower");
			navigation.style.display = 'none';
		}else{
			container.closest('.cursor-follower-inner').classList.remove("swiper-disabled-follower");
			navigation.style.display = 'inline-flex';
		}
	}

}
